import { Injectable, EventEmitter } from '@angular/core';    
import { Subscription } from 'rxjs/internal/Subscription'; 
import { IFundingAccount } from '../interfaces/funding-account';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  // invokeServiceComponentEvent = new EventEmitter();  
  invokeAchFundingAccountExceptionEvent = new EventEmitter();
  invokeCardFundingAccountExceptionEvent = new EventEmitter();
  invokeFundingAccountChosenEvent = new EventEmitter();  
  invokeAchElementValueChanged = new EventEmitter();  
  invokeCardElementValueChanged = new EventEmitter();  
  subsVar!: Subscription;    
    
  constructor() {
    // this.subsVar = new Subscription();
  }    
    
  // onServiceComponentEvent(message: string) {    
  //   this.invokeServiceComponentEvent.emit({message: message});    
  // } 

  onAchFundingAccountException(message: string) {    
    // console.log('EventEmitterService - onAchFundingAccountException', message);
    this.invokeAchFundingAccountExceptionEvent.emit(message);    
  }   

  onCardFundingAccountException(message: string) {    
    // console.log('EventEmitterService - onCardFundingAccountException', message);
    this.invokeCardFundingAccountExceptionEvent.emit(message);    
  }   

  onFundingAccountChosen(fundingAccount: IFundingAccount) {    
    this.invokeFundingAccountChosenEvent.emit(fundingAccount);    
  }   

  onAchElementValueChanged() {
    this.invokeAchElementValueChanged.emit();
  }

  onCardElementValueChanged() {
    this.invokeCardElementValueChanged.emit();
  }

}
